import { createAsyncThunk } from '@reduxjs/toolkit'
import { STORE_PHONE, STORE_STATUS_INITIALIZED } from 'constants/store'
import { ErrorStore, PhoneResponse } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type PhoneState = {
  options: PhoneResponse[]
  selectedId: string
  selectedPhone: string
}

type State = GenericState<
  PhoneState,
  {
    data: string
    error_id: string
  }
>

export const initialState: State = {
  data: {
    options: [],
    selectedId: '',
    selectedPhone: '',
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchPhones = createAsyncThunk<
  PhoneState,
  Promise<PhoneState>,
  Payload
>(STORE_PHONE, async (promise: Promise<PhoneState>, { rejectWithValue }) => {
  try {
    const response = await promise
    return response
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message, details: e })
  }
})

const extraReducers: ExtraReducers = createReducers<
  PhoneState,
  PhoneState,
  Payload
>(fetchPhones, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_PHONE,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear, success } = actions

export { clear, success }

export default reducer
